import {TillageSystemModel} from '../../model/md/TillageSystemModel.js';
import {BaseCollection} from '../BaseCollection';

/**
 * @class TillageSystemCollection
 * @extends BaseCollection
 */
export class TillageSystemCollection extends BaseCollection {

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'md2';
        this.resource = 'tillage-systems';
    }

    get model () {

        return TillageSystemModel;
    }
}


// WEBPACK FOOTER //
// ./shared/collection/md/TillageSystemCollection.js